import { HttpClient } from "@angular/common/http";
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  AfterViewInit,
  Output,
  EventEmitter,
} from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { IOption } from "ng-select";
import { AuthenticationService } from "../../services/authentication.service";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs/Subject";
import { DmsAccessService } from "../../services/dms-access.service";
import { DownloadService } from "../../services/download.service";
import { HelperService } from "../../services/helper.service";
import { TosterMessageService } from "../../services/toster-message.service";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from "ngx-bootstrap/modal";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfigurationService } from "../../services/configuration.service";
import { ObjectivesService } from "../../services/objectives.service";
import { NavigationCompanyAssignService } from "../../services/navigation-company-assign.service";
import { RilrService } from "../../services/rilr.service";

@Component({
  selector: "app-approval-roles-master-modal.component",
  templateUrl: "./approval-roles-master-modal.component.html",
  providers: [
    ConfigurationService,
    DownloadService,
    DmsAccessService,
    ObjectivesService,
    NavigationCompanyAssignService,
    RilrService,
  ],
})
export class ApprovalRoleMasterModalComponent implements OnInit {
  toolTipHtml: string;
  dtOptions: any = {};
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtTrigger: Subject<any> = new Subject();
  userAccess: any;
  isFilterEnabled: boolean = false;
//   public bsModalRefLocation: BsModalRef;
  @ViewChild("swalModalNotAccess") swalModalNotAccess: any;
  @ViewChild("swalModalDeleteDesignation") swalModalDeleteDesignation: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("swalModalDeleteElementMaster") swalModalDeleteElementMaster: any;
  @ViewChild("swalModalDeleteProficiencyMaster")
  swalModalDeleteProficiencyMaster: any;

  notAccessAlertOpen() {
    this.swalModalNotAccess.show();
  }

  message: string = "";
  public htmlErrorMessage: string = "";

  items: any[];
  totalRec: Number;
  orderCondition: any;
  companySystemID = this.helperService.getSelectedCompanyId();

  @Output() tableReload: EventEmitter<any> = new EventEmitter();
  public userGroupCompany: Array<IOption> = [];
  @ViewChild("swalModalDeleteRole") swalModalDeleteRole: any;

  public moduleList: Array<IOption> = [];
  public empData: Array<IOption> = [];
  isEdit: number;
  auto_id: number;
  public roleStatus: Array<IOption> = [];



  constructor(
    private tosterMessageService: TosterMessageService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private helperService: HelperService,
    private configurationService: ConfigurationService,
    private objectivesService: ObjectivesService,
    private navigationCompanyAssignService: NavigationCompanyAssignService,
    private rilrService: RilrService
  ) {}

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }

  closeModalAfterCreate() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("questionbank_closed");
  }


  ngOnInit() {
    console.log(this.moduleList);
  }

  public employeeOption: Array<IOption> = [];

  public typehead(value: any): void {
    let that = this;
    if (value.length > 2) {
      that.getEmployees(value);
    } else {
      that.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.employeeOption = [];
    that.rilrService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.employeeOption = [];
          that.employeeOption =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
          console.log(that.employeeOption);
        },
        (err) => {
          console.log(err);
          that.employeeOption = [];
        }
      );
  }

  addRoleEmployees(formData: any) {
    this.spinner.show();
    const requestData = {
      master_role_id: formData.master_role_id,
      employee_id: formData.employee_id,
      emp_status: formData.emp_status,
      company_id: this.companySystemID,
    };
    console.log(requestData);

    if(formData.master_role_id === undefined || formData.master_role_id === null || 
        formData.employee_id === undefined || formData.employee_id === null || 
        formData.emp_status === undefined || formData.emp_status === null
    ) {
        this.tosterMessageService.showError("Sorry","Please fill the all fields.");
        this.spinner.hide();
        return;
    }

    let that = this;
    that.objectivesService
      .addRoleEmployees()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          this.tosterMessageService.showSuccess(
            "Success",
            "New Role Employee Successfully Added."
          );
          that.closeModalAfterCreate();
          this.tableReload.emit();
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.tosterMessageService.showError("Sorry","Invalid input!.");
          that.closeModalAfterCreate();
          this.spinner.hide();
        }
      );
    this.tableReload.emit();
  }





  getRoleStatusPlaceholder(role_status: number): string {
    return role_status === 1 ? 'Active' : 'Not Active';
  }



  updateRoleEmployees() {
    let that = this;
    const requestData = {
      auto_id: that.auto_id,
      empData: that.empData,
    };
    console.log(requestData);

    that.objectivesService
      .updateRoleEmployees()
      .post(requestData)
      .subscribe(
        (resp: any) => {
          console.log(resp);
          this.tosterMessageService.showSuccess(
            "Success",
            "Role Employee Successfully Updated."
          );
          that.closeModalAfterCreate();
          this.tableReload.emit();
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.tosterMessageService.showError("Sorry","Invalid input!.");
          that.closeModalAfterCreate();
          this.spinner.hide();
        }
      );
    this.tableReload.emit();
  }





}



// WEBPACK FOOTER //
// /app/src/app/configuration/approval-roles-master-modal/approval-roles-master-modal.component.ts